/* Merlen Bakehouse — Shopify theme interactions */
(function(){
  // Sticky header
  const header = document.querySelector('.site-header');
  const onScroll = () => { if(header) header.classList.toggle('scrolled', window.scrollY > 40); };
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  // Mobile menu
  const toggle = document.querySelector('.nav-toggle');
  const menu = document.querySelector('.mobile-menu');
  if(toggle && menu){
    toggle.addEventListener('click', ()=> menu.classList.add('open'));
    menu.querySelectorAll('a,.close').forEach(el=> el.addEventListener('click', ()=> menu.classList.remove('open')));
  }

  // Scroll reveal
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  }, {threshold:0.14, rootMargin:'0px 0px -40px 0px'});
  document.querySelectorAll('.reveal').forEach(el=> io.observe(el));
  // Safety net: never let a .reveal stay invisible once it's reached the viewport
  // (covers fast scrolling, anchor jumps, and back-navigation that the observer can skip)
  const revealSweep = ()=>{
    document.querySelectorAll('.reveal:not(.in)').forEach(el=>{
      if(el.getBoundingClientRect().top < window.innerHeight){ el.classList.add('in'); io.unobserve(el); }
    });
  };
  window.addEventListener('scroll', revealSweep, {passive:true});
  window.addEventListener('load', revealSweep);
  window.addEventListener('resize', revealSweep, {passive:true});

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(q=>{
    q.addEventListener('click', ()=>{
      const item = q.closest('.faq-item');
      const a = item.querySelector('.faq-a');
      const open = item.classList.toggle('open');
      a.style.maxHeight = open ? a.scrollHeight + 'px' : 0;
    });
  });
})();

/* Saturday Drop — countdown + variant picker */
(function(){
  // Countdown
  document.querySelectorAll('.drop-countdown').forEach(function(cd){
    var weekday = parseInt(cd.dataset.dropWeekday || '6', 10); // 6 = Saturday
    var hour = parseInt(cd.dataset.dropHour || '9', 10);
    var live = cd.querySelector('.cd-live');
    var units = cd.querySelector('.cd-units');
    function pad(n){ return (n<10?'0':'')+n; }
    function tick(){
      var now = new Date();
      var isLive = (now.getDay() === weekday && now.getHours() >= hour);
      if(isLive){
        if(units) units.style.display='none';
        if(live) live.hidden=false;
        return;
      }
      if(units) units.style.display='';
      if(live) live.hidden=true;
      var t = new Date(now); t.setHours(hour,0,0,0);
      var add = ((weekday - now.getDay()) + 7) % 7;
      if(add === 0 && now >= t) add = 7;
      t.setDate(now.getDate() + add);
      var diff = Math.max(0, t - now);
      var d = Math.floor(diff/86400000);
      var h = Math.floor(diff%86400000/3600000);
      var m = Math.floor(diff%3600000/60000);
      var s = Math.floor(diff%60000/1000);
      var set = function(sel,v){ var el=cd.querySelector(sel); if(el) el.textContent=pad(v); };
      set('[data-d]',d); set('[data-h]',h); set('[data-m]',m); set('[data-s]',s);
    }
    tick(); setInterval(tick, 1000);
  });

  // Variant picker (Saturday Drop card)
  document.querySelectorAll('.drop-variants').forEach(function(group){
    var form = group.closest('form');
    if(!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.getElementById('dropPrice');
    var addBtn = form.querySelector('button[name="add"]');
    group.querySelectorAll('.variant-btn').forEach(function(btn){
      btn.addEventListener('click', function(){
        if(btn.hasAttribute('disabled')) return;
        group.querySelectorAll('.variant-btn').forEach(function(b){ b.classList.remove('active'); });
        btn.classList.add('active');
        if(idInput) idInput.value = btn.dataset.variantId;
        if(priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
        if(addBtn){
          if(!addBtn.dataset.label){ addBtn.dataset.label = addBtn.innerHTML; }
          var avail = btn.dataset.available === 'true';
          addBtn.disabled = !avail;
          addBtn.innerHTML = avail ? addBtn.dataset.label : 'Sold Out';
        }
      });
    });
  });
})();

/* Drop product page — pickup window slots + inventory on variant change */
(function(){
  // Pickup window selection -> line item property, scoped PER product form
  // (the Saturday Drop page can show two reserve forms — rolls + cookies —
  //  each with its own slot grid and hidden "Pickup window" input).
  document.querySelectorAll('form').forEach(function(form){
    var slots = form.querySelectorAll('.slot-grid .slot');
    if(!slots.length) return;
    var input = form.querySelector('input[name="properties[Pickup window]"]');
    slots.forEach(function(s){
      if(s.classList.contains('full')) return;
      s.addEventListener('click', function(){
        slots.forEach(function(x){ x.classList.remove('active'); });
        s.classList.add('active');
        if(input) input.value = s.dataset.slot || s.textContent.trim();
      });
    });
  });

  // Update inventory readout when a variant pill is chosen
  var invEl = document.getElementById('dropInv');
  function paintInv(q){
    if(!invEl) return;
    var dot = invEl.querySelector('.inv-dot');
    var txt = invEl.querySelector('.inv-text');
    var unit = invEl.dataset.unit || 'remaining';
    if(isNaN(q)){ return; }
    dot.className = 'inv-dot' + (q <= 0 ? ' out' : (q <= 8 ? ' low' : ''));
    if(q <= 0) txt.textContent = 'Sold out for this week';
    else if(q <= 8) txt.textContent = q + ' ' + unit + ' · Selling fast';
    else txt.textContent = q + ' ' + unit;
  }
  document.querySelectorAll('.drop-variants .variant-btn').forEach(function(btn){
    btn.addEventListener('click', function(){
      if(btn.dataset.inv !== undefined) paintInv(parseInt(btn.dataset.inv, 10));
    });
  });
})();

/* Drop reserve page — swap hero image when switching box size */
(function(){
  var img = document.getElementById('dropImage');
  if(!img) return;
  document.querySelectorAll('.drop-variants .variant-btn[data-img]').forEach(function(btn){
    btn.addEventListener('click', function(){ if(btn.dataset.img) img.src = btn.dataset.img; });
  });
})();

/* Cart — change pickup window (updates the line item property) */
(function(){
  var selects = document.querySelectorAll('select.cart-pickup');
  if(!selects.length) return;
  selects.forEach(function(sel){
    var prev = sel.value;
    sel.addEventListener('change', function(){
      var key = sel.dataset.key, val = sel.value;
      sel.disabled = true;
      var note = sel.parentNode.querySelector('.cart-pickup-saved');
      if(note){ note.textContent = 'Saving…'; note.hidden = false; }
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, properties: { 'Pickup window': val } })
      })
      .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
      .then(function(){ prev = val; sel.disabled = false; if(note){ note.textContent = 'Updated ✓'; setTimeout(function(){ note.hidden = true; }, 2000); } })
      .catch(function(){ sel.value = prev; sel.disabled = false; if(note){ note.textContent = 'Could not update — try again'; } });
    });
  });
})();

/* Ingredients page — shared product tabs (one tab bar spans every ingredients
   section on the page, so ingredients can be split across multiple 50-block
   sections under a single set of tabs). Sub-tabs stay scoped to their panel. */
(function(){
  // One shared tab bar: keep the first [data-ing-tabs], drop any extras.
  var bars = document.querySelectorAll('[data-ing-tabs]');
  if (bars.length) {
    var bar = bars[0];
    for (var i = 1; i < bars.length; i++) { bars[i].remove(); }

    // Every panel on the page, any section, in document order.
    var panels = Array.prototype.slice.call(document.querySelectorAll('.ing-panel'));
    var groups = [];
    panels.forEach(function(p){
      var g = p.dataset.group;
      if (g && groups.indexOf(g) === -1) groups.push(g);
    });

    // Build the tab buttons from the discovered groups.
    bar.innerHTML = '';
    groups.forEach(function(g, idx){
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ing-tab' + (idx === 0 ? ' active' : '');
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
      btn.dataset.group = g;
      // Render a trailing "coming soon" as a small badge rather than plain text.
      // data-group keeps the full string so panel matching is unaffected.
      var soon = g.match(/^(.*?)[\s—–-]*coming soon\s*$/i);
      if (soon) {
        btn.appendChild(document.createTextNode(soon[1].trim() + ' '));
        var badge = document.createElement('span');
        badge.className = 'soon-badge';
        badge.textContent = 'Coming soon';
        btn.appendChild(badge);
      } else {
        btn.textContent = g;
      }
      bar.appendChild(btn);
    });

    function activate(group){
      bar.querySelectorAll('.ing-tab').forEach(function(t){
        var on = t.dataset.group === group;
        t.classList.toggle('active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function(p){
        p.classList.toggle('show', p.dataset.group === group);
      });
    }

    bar.addEventListener('click', function(e){
      var b = e.target.closest('.ing-tab');
      if (b) activate(b.dataset.group);
    });

    if (groups.length) activate(groups[0]);
  } else {
    // No shared tab bar on the page (e.g. show_tabs off everywhere) — reveal all
    // panels so the section never blacks out with no way to switch tabs.
    document.querySelectorAll('.ing-panel').forEach(function(p){ p.classList.add('show'); });
  }
  // Sub tabs → show the matching .ing-subpanel within the same panel
  document.querySelectorAll('.ing-subtabs').forEach(function(bar){
    var subs = bar.querySelectorAll('.ing-subtab');
    var panel = bar.closest('.ing-panel') || bar.parentNode;
    subs.forEach(function(st){
      st.addEventListener('click', function(){
        var sub = st.dataset.sub;
        subs.forEach(function(s){
          var on = s === st;
          s.classList.toggle('active', on);
          s.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panel.querySelectorAll('.ing-subpanel').forEach(function(p){
          p.classList.toggle('show', p.dataset.sub === sub);
        });
      });
    });
  });
})();
